// hello wHirled => Hello Whirled
export function toTitleCase(str) {
  if (!str || typeof str !== "string") {
    return "";
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

// hello wHirled => Hello whirled
export function toSentenceCase(str) {
  if (!str || typeof str !== "string") {
    return "";
  }
  return str[0].toUpperCase() + str.substring(1).toLowerCase();
}

// ["hat", "dog", "cat"] => "hat, dog, and cat"
export function arrToStrWithCommas(arr) {
  if (!Array.isArray(arr) || arr.length === 0) {
    return "";
  }

  if (arr.length === 1) {
    return arr[0];
  }

  if (arr.length === 2) {
    return `${arr[0]} and ${arr[1]}`;
  }

  return arr.reduce((cummulative, el, pass) => {
    return cummulative + (pass + 1 < arr.length ? ", " : ", and ") + el;
  });
}

// {width: 200, height: 200} => `W: 200px by H: 200px`
export function formatImageDimensionsStr(dimensions) {
  if (
    dimensions &&
    dimensions.width &&
    dimensions.height &&
    typeof dimensions.width === "number" &&
    typeof dimensions.height === "number"
  ) {
    return `W: ${dimensions.width}px by H: ${dimensions.height}px`;
  } else {
    return "";
  }
}

// return the index of the nth pattern match
export function nthIndex(str, pattern, n) {
  try {
    var L = str.length,
      i = -1;
    while (n-- && i++ < L) {
      i = str.indexOf(pattern, i);
      if (i < 0) break;
    }
    return i;
  } catch (err) {
    return "";
  }
}

export function isValidJSONStr(str) {
  try {
    if (typeof str !== "string") {
      return false;
    }
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function numberWithCommas(n) {
  if ((n || n === 0) && typeof n === "number") {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else if (typeof n === "string" && !isNaN(n)) {
    return n;
  } else {
    throw new TypeError("Invalid type, value must be number");
  }
}

export function splitOn(str, index) {
  if (str === "" || str.length === 0 || typeof str !== "string") {
    console.warn("No string value to splitOn");
    return null;
  } else if (typeof index !== "number" || index === 0) {
    console.warn("Invalid index supplied");
    return null;
  }
  return [str.slice(0, index), str.slice(index)];
}

export function camelToTitle(str) {
  if (typeof str !== "string") {
    return "";
  }
  const result = str?.replace(/([A-Z])/g, " $1");
  return result ? result.charAt(0).toUpperCase() + result.slice(1) : ""; // capitalize the first letter - as an example.
}

export function snakeToCamel(str) {
  return str.replace(/(\_\w)/g, (firstLetter) => firstLetter[1].toUpperCase());
}

export function toSnakeCase(string) {
  if (typeof string != "string") {
    throw new TypeError();
  }

  return (
    string &&
    string
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((s) => s.toLowerCase())
      .join("_")
  );
}

export function snakeToTitle(string) {
  if (typeof string != "string") {
    throw new TypeError();
  }

  return string
    .split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.substr(1).toLowerCase())
    .join(" ");
}

export function trimURL(str) {
  return str
    .replace(/\s+/g, "")
    .slice(
      Math.max(
        str.lastIndexOf(":") === -1 ? 0 : str.lastIndexOf(":") + 1,
        str.lastIndexOf("//") === -1 ? 0 : str.lastIndexOf("//") + 2
      )
    );
}

export function missingURLHeader(str) {
  return !(
    str.slice(0, 8) === "https://" ||
    str.slice(0, 7) === "http://" ||
    str.slice(0, 4) === "tel:" ||
    str.slice(0, 7) === "mailto:"
  );
}

export function includesLineBreak(str) {
  return (str.match(/\n/g) || []).length > 0;
}

export function normalizingString(str) {
  let bufferEnd = str.replace(/[\t\r\n]+/g, " ");
  bufferEnd = bufferEnd.trimLeft();
  return bufferEnd.trimRight();
}

export function replaceTabWithSpace(tabChar, spaceToReplace = 4) {
  if (!Number.isInteger(spaceToReplace)) {
    throw new TypeError("Invalid type, secondary parameter must be number");
  }
  return tabChar.replace(/[\t]/g, " ".repeat(spaceToReplace));
}

export function camelize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, char) => char.toUpperCase());
}

export function isLatin1Only(str) {
  return !!str.match(
    /^[\n\t !\"#$%&'()*+,-./0-9:;<=>?@A-Z\[\\\]^_`a-z{|}~€‚ƒ„…†‡ˆ‰Š‹ŒŽ''""•–—˜™š›œžŸ ¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]*$/
  );
}

export function onlyNumbersAndLetters(str) {
  if (typeof str !== "string") {
    throw new TypeError("Not A String");
  }
  let letters = /^[0-9a-zA-Z]+$/;
  return str ? !!str.match(letters) : true;
}

export function noSpaces(str) {
  if (typeof str !== "string") {
    throw new TypeError("Not A String");
  }
  return str ? !!str.match(/^\S+$/g) : true;
}
export function convertToStringLower(val = "") {
  val = typeof val !== "string" ? `${val ? val : ""}` : val;
  return val.toLowerCase();
}

export function numericOnly(str) {
  if (typeof str !== "string") {
    throw new TypeError("Invalid type, value must be string");
  }
  return str ? !!str.match(/^\d+$/) : false;
}

export function stringContainsSubstringsOfSet(str = "", contains = []) {
  if (typeof str !== "string" || !Array.isArray(contains)) {
    throw new TypeError(
      "Invalid type, var str must be a string and var contains must be an array"
    );
  }
  return contains.filter((subStr) => str.indexOf(subStr) > -1);
}

export function isVersionFormat(str) {
  if (typeof str !== "string") {
    throw new TypeError("Invalid type, value must be string");
  }
  const re = /v{1}\d{1,}\.\d{1,}/g;

  return re.test(str);
}

export function sortNumbericString(strToCheck, str) {
  if (typeof strToCheck !== "string" || typeof str !== "string") {
    throw new TypeError("Invalid type, value must be string");
  }

  return strToCheck.localeCompare(str, undefined, {
    numeric: true,
    sensitivity: "base",
  });
}

export function hasSpecialCharacter(str) {
  if (typeof str !== "string") {
    throw new TypeError("Invalid type, value must be string");
  }
  const re = /[`~!@#$%^&*≈()|+\=?;:'",.<>\{\}\[\]\\\/]/gi;
  return re.test(str);
}
// "testStr => test-str" "test str=>test-str"
export function toKebabCase(string) {
  if (typeof string != "string") {
    throw new TypeError();
  }
  return (
    string &&
    string
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((s) => s.toLowerCase())
      .join("-")
  );
}

export function isSnakeCase(string) {
  if (typeof string != "string") {
    throw new TypeError();
  }
  return !!string.match(/(.*?)_([a-zA-Z])*/);
}

